import React from 'react';
import {classes, style} from './rich-text-view.st.css';
import {reactSetInnerHtml} from "../react-utils/react-utils";
import {generateHTML} from "@tiptap/html";
import {RichTextContent, RichTextExtensions} from "./rich-text";

export const RichTextView = React.memo(function RichTextView (props: RichTextView.Props) {
    const {
        richText,
        extensions,

        className,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
            {...(
                typeof richText === 'string' ?
                    {children: richText} :
                    reactSetInnerHtml(generateHTML(richText, extensions))
            )}
        />
    );
});

export namespace RichTextView {

    export interface Props extends React.HTMLAttributes<any> {
        children?: undefined;
        richText: RichTextContent;
        extensions: RichTextExtensions
    }
}
